import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal } from "antd";

const SeasonDetailsList = (props) => {
  const { addForm, update,sId} = props;
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, seasonId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Season detail?",
      onOk() {
      

        deleteOperation(
          {
            url: `/api/seasons/?orgId=${localStorage.getItem(
              "orgId"
            )}&seasonId=${seasonId}&serviceId=${serviceId}`,
            method: "DELETE",
          },
          (data) => {
            if(data.success) {
              toast.success(data.success);
            }
       
            if (data.error) {
              toast.error(data.error);
            }
            FillDetail();
          }
        );
      },
      onCancel() { },
    });
  };

  const { sendRequest: getSeasonData } = useHttp();

  const FillDetail = () => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res)
          // console.log(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getSeasonData]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);



  const handleSearch = (e) => {
   
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
      
        item.seasonName.toLowerCase().includes(filetrtext) ||
        item.seasonEndMonth.toLowerCase().includes(filetrtext) ||
        item.seasonStartMonth.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-9">
            <label className="card-title  my-3">
              {" "}
              &nbsp; &nbsp;Season Details{" "}
            </label>{" "}
          </div>

          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary my-2"
              onClick={() => {
                addForm(true);
                sId(serviceId);
                props.update(false);
              }}
            >
              Add Season Details
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-5"> </div>
                      <div className="col-4"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Season Name</th>
                            <th>Season Start Month</th>
                            <th>Season End Month</th>
                            <th>is Current Season</th>
                            <th>Status</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.seasonName}</td>
                                <td>{x.seasonStartMonth}</td>
                                <td>{x.seasonEndMonth}</td>
                                <td>
                                  {x.isCurrentSeason == 1 ? "Yes" : "No"}
                                </td>


                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                      props.sId(serviceId);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) => handleDelete(e, x.seasonId)}
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SeasonDetailsList;
